/**
 * if the given element's index is last in array it returns true
 */
export const isLastElement = (array: any[], index: number): boolean => (
    index === (array.length - 1)
)